import cart from './cart'
export default `mutation setShippingAddressesOnCart($input: SetShippingAddressesOnCartInput) {
  setShippingAddressesOnCart(input: $input) {
    cart { ${cart} }
   }
 }
`
